<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter">
<p class="nonindent"><strong>eat•ing dis•or•der</strong></p>
<p class="nonindent">(e′tĭng dĭs-ôr′dƏr)►</p>
<div class="block">
<p class="nonindent"><em>n.</em> <strong>1.</strong> Serious, potentially life-threatening, biologically based mental illness, usually characterized by daily functioning affected by disordered body image, a preoccupation with and anxiety related to food and eating, and disordered eating.</p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// fm2.vue?bf4563d0